var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import ReactDOM from 'react-dom';
import FileSaver from 'file-saver';
import * as Constant from './Constant';
import TableIcon from '../assets/icons/layout.svg';
import BarChartIcon from '../assets/icons/bar-chart.svg';
import PieChartIcon from '../assets/icons/pie-chart.svg';
import LineChartIcon from '../assets/icons/activity.svg';
import html2canvas from "html2canvas";
export var presentations = JSON.stringify([
    {
        icon: TableIcon,
        id: Constant.PRESENTATION_TYPE_TABLE,
        name: Constant.PRESENTATION_TYPE_TABLE
    },
    {
        icon: BarChartIcon,
        id: Constant.PRESENTATION_TYPE_BAR,
        name: Constant.PRESENTATION_TYPE_BAR
    },
    {
        icon: BarChartIcon,
        id: Constant.PRESENTATION_TYPE_BAR_100,
        name: Constant.PRESENTATION_TYPE_BAR_100
    },
    {
        icon: PieChartIcon,
        id: Constant.PRESENTATION_TYPE_PIE,
        name: Constant.PRESENTATION_TYPE_PIE
    },
    {
        icon: LineChartIcon,
        id: Constant.PRESENTATION_TYPE_SIMPLE_LINE,
        name: Constant.PRESENTATION_TYPE_SIMPLE_LINE
    }
]);
export var presentationsMultipleCharts = JSON.stringify([
    {
        icon: [BarChartIcon, LineChartIcon],
        id: Constant.PRESENTATION_TYPE_STACKED_AREA,
        name: Constant.PRESENTATION_TYPE_STACKED_AREA
    },
    {
        icon: [LineChartIcon, LineChartIcon],
        id: Constant.PRESENTATION_TYPE_COMPARISION_LINE,
        name: Constant.PRESENTATION_TYPE_COMPARISION_LINE
    },
    {
        icon: [BarChartIcon, LineChartIcon],
        id: Constant.PRESENTATION_TYPE_COMPOSE,
        name: Constant.PRESENTATION_TYPE_COMPOSE
    },
    {
        icon: [LineChartIcon, LineChartIcon, LineChartIcon],
        id: Constant.PRESENTATION_TYPE_MULTIPLE_LINE,
        name: Constant.PRESENTATION_TYPE_MULTIPLE_LINE
    }
]);
export var lineTypeComposeInfos = [
    {
        id: 14,
        name: "NOT_GA",
        label: "REQUEST",
        type: "NOT_GA"
    },
    {
        id: 34,
        name: "DAU",
        label: "DAU",
        type: "GA"
    },
    {
        id: 36,
        name: "GA",
        label: "PV",
        type: "GA"
    },
    {
        id: 57,
        name: "DEVICE_TYPE",
        label: "DEVICE TYPE",
        type: "NOT_GA"
    },
    {
        id: 68,
        name: "SESSION",
        label: "SESSION",
        type: "GA"
    },
    {
        id: 16,
        name: "FILL_RATE",
        label: "FILL RATE",
        type: "NOT_GA"
    },
    {
        id: 18,
        name: "CTR",
        label: "CTR",
        type: "NOT_GA"
    },
    {
        id: 20,
        name: "CPC",
        label: "CPC",
        type: "NOT_GA"
    },
    {
        id: 19,
        name: "CPM",
        label: "CPM",
        type: "NOT_GA"
    },
    {
        id: 30,
        name: "CPM_IMP",
        label: "CPM(/IMP)",
        type: "NOT_GA"
    },
    {
        id: 46,
        name: "PUBLISHER_CPC",
        label: "PUBLISHER CPC",
        type: "NOT_GA"
    },
    {
        id: 29,
        name: "PUBLISHER_CPM",
        label: "PUBLISHER CPM",
        type: "NOT_GA"
    },
    {
        id: 33,
        name: "PUBLISHER_CPM_IMP",
        label: "PUBLISHER CPM(/IMP)",
        type: "NOT_GA"
    },
    {
        id: 44,
        name: "vCPM",
        label: "vCPM",
        type: "NOT_GA"
    },
    {
        id: 45,
        name: "PUBLISHER_vCPM",
        label: "PUBLISHER vCPM",
        type: "NOT_GA"
    },
    {
        id: 71,
        name: "SESSION_TOTAL_REVENUE",
        label: "Total Revenue(/Session)",
        type: "GA"
    },
    {
        id: 39,
        name: "PV_TOTAL_REVENUE",
        label: "Total Revenue(/PV)",
        type: "GA"
    },
    {
        id: 42,
        name: "PV_PUBLISHER_REVENUE",
        label: "Publisher Revenue(/PV)",
        type: "GA"
    }
];
export var lineTypeComposeOptions = [
    {
        value: "SESSION",
        label: "Session"
    },
    {
        value: "DAU",
        label: "DAU"
    },
    {
        value: "GA",
        label: "PV"
    },
    {
        value: "NOT_GA",
        label: "Req"
    },
    {
        value: "FILL_RATE",
        label: "Fill Rate",
        defaultField: "fill_rate"
    },
    {
        value: "CTR",
        label: "CTR",
        defaultField: "ctr"
    },
    {
        value: "CPC",
        label: "CPC",
        defaultField: "cpc"
    },
    {
        value: "CPM",
        label: "CPM",
        defaultField: "cpm"
    },
    {
        value: "CPM_IMP",
        label: "Cpm(/imp)",
        defaultField: "cpm_per_imp"
    },
    {
        value: "PUBLISHER_CPC",
        label: "Publisher CPC",
        defaultField: "publisher_cpc"
    },
    {
        value: "PUBLISHER_CPM",
        label: "Publisher CPM",
        defaultField: "pcpm"
    },
    {
        value: "PUBLISHER_CPM_IMP",
        label: "Publisher CPM(/Imp)",
        defaultField: "pimp"
    },
    {
        value: "vCPM",
        label: "vCPM",
        defaultField: "v_cpm"
    },
    {
        value: "PUBLISHER_vCPM",
        label: "Publisher vCPM",
        defaultField: "publisher_v_cpm"
    },
    {
        value: "SESSION_TOTAL_REVENUE",
        label: "Total Revenue(/Session)",
        defaultField: "session_total_revenue"
    },
    {
        value: "PV_TOTAL_REVENUE",
        label: "Total Revenue(/PV)",
        defaultField: "pv_total_revenue"
    },
    {
        value: "PV_PUBLISHER_REVENUE",
        label: "Publisher Revenue(/PV)",
        defaultField: "pv_publisher_revenue"
    }
];
export var barTypeComposeOptions = [
    {
        value: "request",
        label: "Request"
    },
    {
        value: "impression",
        label: "Impression"
    },
    {
        value: "click",
        label: "Click"
    },
    {
        value: "total_revenue",
        label: "Total Revenue"
    },
    {
        value: "publisher_revenue",
        label: "Publisher Revenue"
    },
    {
        value: "payout_amount",
        label: "Payout Amount"
    },
    {
        value: "v_impression",
        label: "vImpression"
    }
];
export var metricTypeIDList = [
    {
        id: 1,
        field: "platform_inventory_id"
    }, {
        id: 4,
        field: "platform_id"
    }, {
        id: 6,
        field: "media_id"
    }, {
        id: 7,
        field: "pubdesk_inventory_id"
    }, {
        id: 25,
        field: "publisher_id"
    }, {
        id: 48,
        field: "platform_group_id"
    }, {
        id: 50,
        field: "sub_platform_group_id"
    }
];
export var exportPNGFileFromChart = function (chartRef, nameImage, callbackResponseUrlImage) { return __awaiter(void 0, void 0, void 0, function () {
    var chartDom, chartContainer, canvas, dataUrl, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(chartRef && chartRef.current)) return [3 /*break*/, 7];
                chartDom = ReactDOM.findDOMNode(chartRef.current);
                if (!chartDom) {
                    callbackResponseUrlImage(null);
                    return [2 /*return*/];
                }
                chartContainer = chartDom.querySelector("div");
                if (!chartContainer) return [3 /*break*/, 5];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, html2canvas(chartContainer, { useCORS: true })];
            case 2:
                canvas = _a.sent();
                dataUrl = canvas.toDataURL("image/png");
                callbackResponseUrlImage(dataUrl);
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                console.error("Oops, something went wrong with html2canvas!", error_1);
                callbackResponseUrlImage(null);
                return [3 /*break*/, 4];
            case 4: return [3 /*break*/, 6];
            case 5:
                callbackResponseUrlImage(null);
                _a.label = 6;
            case 6: return [3 /*break*/, 8];
            case 7:
                callbackResponseUrlImage(null);
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}); };
export var exportPNGFromChart = function (pngFile, name) {
    FileSaver.saveAs(pngFile, name);
};
var copyStylesInline = function (destinationNode, sourceNode) {
    var containerElements = ["svg", "g"];
    for (var cd = 0; cd < destinationNode.childNodes.length; cd++) {
        var child = destinationNode.childNodes[cd];
        if (containerElements.indexOf(child.tagName) != -1) {
            copyStylesInline(child, sourceNode.childNodes[cd]);
            continue;
        }
        var style = sourceNode.childNodes[cd].currentStyle || window.getComputedStyle(sourceNode.childNodes[cd]);
        if (style == "undefined" || style == null)
            continue;
        for (var st = 0; st < style.length; st++) {
            child.style.setProperty(style[st], style.getPropertyValue(style[st]));
        }
    }
};
export var svgToPng = function (svg, width, height) {
    return new Promise(function (resolve, reject) {
        var copy = svg.cloneNode(true);
        copyStylesInline(copy, svg);
        var canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        // Set background to white
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, width, height);
        var data = (new XMLSerializer()).serializeToString(copy);
        var DOMURL = window.URL || window.webkitURL || window;
        var svgBlob = new Blob([data], { type: "image/svg+xml;charset=utf-8" });
        var dataUrl = DOMURL.createObjectURL(svgBlob);
        var img = new Image(width, height);
        img.onload = function () {
            ctx.drawImage(img, 0, 0);
            var imageData = canvas.toDataURL("image/png", 1.0);
            resolve(imageData);
        };
        img.onerror = function () { return reject(); };
        img.src = dataUrl;
    });
};
export var renderMarginChart = function (value, marginData, property, metric, defaultValue) {
    var valueString = "" + value;
    var valueLength = valueString.length;
    if (metric && metric.category && (metric.category == "COST" || metric.category == "PERCENTAGE")) {
        valueLength += 1;
    }
    if (valueLength >= 8 && valueLength < 11) {
        marginData[property] = 40;
    }
    else if (valueLength >= 11) {
        marginData[property] = 60;
    }
    else {
        marginData[property] = defaultValue ? defaultValue : 10;
    }
};
